<template>
  <base-layout :loading="loading">
    <v-row
      no-gutters
      justify="space-between"
      class="pt-3">
      <v-col
        md="6"
        cols="12"
        class="d-flex align-center search-product">
        <v-row no-gutters>
          <v-col cols="12">
            <v-text-field
              v-model="search"
              label="Search"
              dense
              append-icon="mdi-magnify" />
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-data-table
          :headers="headers"
          :items="brands"
          :search="search"
          disable-pagination
          hide-default-footer
          class="elevation-1">
          <template v-slot:top>
            <v-dialog
              v-model="dialog"
              max-width="760px">
              <v-card>
                <v-card-title>
                  <span class="headline">Brand Management</span>
                </v-card-title>

                <v-card-text>
                  <v-container>
                    <v-row>
                      <v-col cols="12">
                        <v-text-field
                          v-model="editedItem.name"
                          disabled
                          label="ชื่อแบรนด์" />
                      </v-col>
                      <v-col cols="12">
                        <v-text-field
                          v-model="editedItem.tel"
                          type="tel"
                          max-length="10"
                          label="เบอร์ติดต่อ" />
                      </v-col>
                      <v-col cols="12">
                        <v-text-field
                          v-model="editedItem.address"
                          label="ที่อยู่" />
                      </v-col>
                      <v-col cols="12">
                        <v-text-field
                          v-model="editedItem.zipcode"
                          type="number"
                          label="รหัสไปรษณีย์" />
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    color="blue darken-1"
                    text
                    @click="dialog = false">
                    Cancel
                  </v-btn>
                  <v-btn
                    color="blue darken-1"
                    text
                    @click="save">
                    Save
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </template>
          <template v-slot:item.address="{ item }">
            {{ item.address }} {{ item.zipcode }}
          </template>
          <template v-slot:item.actions="{ item }">
            <v-icon
              small
              class="mr-2"
              @click="editItem(item)">
              mdi-pencil
            </v-icon>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </base-layout>
</template>

<script>
import { mapActions } from 'vuex'
import BrandProvider from '@/resources/BrandProvider'

const brandService = new BrandProvider()

export default {
  data () {
    return {
      dialog: false,
      isEdit: true,
      search: '',
      branch: [
        'SQ ONE'
      ],
      page: 1,
      totalOrder: 0,
      brands: [],
      loading: false,
      options: {},
      headers: [
        {
          text: 'แบรนด์',
          sortable: false,
          value: 'name'
        },
        { text: 'เบอร์', value: 'phone1' },
        { text: 'ที่อยู่', value: 'address' },
        { text: '', value: 'actions', sortable: false }
      ],
      editedIndex: -1,
      editedItem: {
        id: null,
        name: '',
        tel: '',
        address: '',
        zipcode: ''
      },
      defaultItem: {
        id: null,
        name: '',
        tel: '',
        address: '',
        zipcode: ''
      }
    }
  },
  computed: {
  },
  async created () {
    await this.getBrands()
  },
  methods: {
    ...mapActions({
      setModal: 'Style/setModal'
    }),
    async getBrands () {
      this.loading = true
      try {
        const { data } = await brandService.getBrands()
        if (data) {
          this.brands = data
        }
      } catch (e) {
        console.error(e)
      }
      this.loading = false
    },
    async save () {
      this.loading = true
      const item = {
        address: this.editedItem.address,
        zipcode: this.editedItem.zipcode,
        tel: this.editedItem.tel
      }
      if (this.validator(item)) {
        try {
          const res = await brandService.updateBrandDetail(this.editedItem.id, {
            address: this.editedItem.address,
            zipcode: this.editedItem.zipcode,
            phone1: this.editedItem.tel,
            phone2: '',
            phone3: ''
          })
          if (res.message === 'done') {
            this.setModal({
              value: true,
              title: 'สำเร็จ',
              message: 'แก้ไขรายการสำเร็จแล้ว',
              confirmOnly: true
            })
            await this.getBrands()
            this.dialog = false
          } else {
            this.setModal({
              value: true,
              title: 'ไม่สำเร็จ',
              message: 'มีบางอย่างผิดพลาด กรุณาลองใหม่อีกครั้ง',
              confirmOnly: true
            })
          }
        } catch (e) {
          console.error(e)
        }
      } else {
        this.setModal({
          value: true,
          title: 'ไม่สำเร็จ',
          message: 'รูปแบบฟอร์มไม่ถูกต้อง',
          confirmOnly: true
        })
      }
      this.loading = false
    },
    editItem (item) {
      this.editedItem.id = item.id
      this.editedItem.name = item.name
      this.editedItem.address = item.address
      this.editedItem.tel = item.phone1
      this.editedItem.zipcode = item.zipcode

      this.dialog = true
    },
    validator (item) {
      const addressCheck = !!item.address
      const telCheck = /^\d{10}$/.test(item.tel)
      const zipcodeCheck = /^\d+$/.test(item.zipcode)

      return addressCheck && telCheck && zipcodeCheck
    }
  }
}
</script>
